import { useMemo } from 'react';

import { CaseStudiesList } from '@/components/sections/common';
import { SectionContentWrapper, SectionWrapper } from '@/components/wrappers';
import { CaseStudyFragment } from '@/graphql/generated';

interface Props {
  caseStudies: CaseStudyFragment[] | undefined;
  caseStudyIdToExclude?: string | null;
}

export const AllCaseStudies = ({ caseStudies, caseStudyIdToExclude }: Props) => {
  const sortedCaseStudies = useMemo(
    () =>
      caseStudies
        ?.sort((a, b) => a.attributes?.position! - b.attributes?.position!)
        .filter((cs) => cs.id !== caseStudyIdToExclude) || [], // exclude featured case study from the main list
    [caseStudies, caseStudyIdToExclude],
  );

  return (
    <SectionWrapper zIndex={0} id="caseStudiesSection" pb={10} position="relative">
      <SectionContentWrapper
        paddingY={undefined}
        pt={{
          base: 2,
          sm: 4,
          md: 4,
        }}
        px={{ base: 5, lg: 20 }}
      >
        <CaseStudiesList caseStudies={sortedCaseStudies} showTags={true} />
      </SectionContentWrapper>
    </SectionWrapper>
  );
};
